import axiosClient from '../api/AxiosConfig';

export const MemberService = {
  CreateMemberCard: async (data) => {
    return (await axiosClient.post('/member/member-card', data)).data;
  },
  GetMemberNotes: async () => {
    return (await axiosClient.get('/member/notes')).data;
  },
  GetListMemberCard: async () => {
    return (await axiosClient.get('/member/member-card')).data;
  },
  DeleteMemberCardById: async (id) => {
    return (await axiosClient.delete(`/member/member-card/${id}`)).data;
  },
  GetMemberCardById: async (id) => {
    return (await axiosClient.get(`/member/member-card/${id}`)).data;
  },
  EditMemberCardById: async (id, data) => {
    return (await axiosClient.put(`/member/member-card/${id}`, data)).data;
  },
  CreateMemberNotes: async () => {
    return (await axiosClient.post('/member/notes')).data;
  },
  EditMemberNotes: async (data) => {
    return (await axiosClient.put('/member/notes', data)).data;
  },
};
